import classnames from "classnames";

import Button from "@/components/button/Button.tsx";
import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";
import {BillingPeriod} from "@/lib/types/billing.ts";

import css from "./BillingPeriodPicker.module.css";

export interface BillingPeriodPickerProps {
  value?: BillingPeriod;
  onChange: (billingPeriod: BillingPeriod) => void;
  percentage?: number;
  disabled?: boolean;
}

export const BillingPeriodPicker = ({
  value = BillingPeriod.MONTH,
  percentage = 16,
  onChange,
  disabled,
}: BillingPeriodPickerProps) => (
  <div className={classnames(css.BillingPeriodPicker, "d-flex")}>
    <TooltipWrapper toolTip={disabled ? "Please contact support to switch to monthly billing." : undefined}>
      <div className={classnames(css.BillingPeriodPickerContainer, "btn-group btn-group-toggle d-flex")}>
        <Button
          type="button"
          disabled={disabled}
          onClick={() => onChange(BillingPeriod.MONTH)}
          className={classnames({
            "text-decoration-line-through": disabled && value !== BillingPeriod.MONTH,
            [css.Selected]: value === BillingPeriod.MONTH,
          })}
        >
          Monthly
        </Button>
        <Button
          type="button"
          disabled={disabled}
          onClick={() => onChange(BillingPeriod.YEAR)}
          className={classnames({
            "text-decoration-line-through": disabled && value !== BillingPeriod.YEAR,
            [css.Selected]: value === BillingPeriod.YEAR,
          })}
        >
          Yearly
        </Button>
      </div>
    </TooltipWrapper>
    {!disabled && value === BillingPeriod.YEAR && (
      <div className="d-flex flex-row align-items-center justify-content-between ms-1">
        <div className={classnames(css.GreenOutlineTongue)}></div>
        <div className={classnames("rounded rounded-3 p-1 px-2 fw-semibold fs-7", css.GreenOutlineBody)}>
          SAVING {percentage}%
        </div>
      </div>
    )}
  </div>
);
